import { useState } from 'react';

const FAQS = [
  {
    q: '天美麻花星空影视真的完全免费吗？',
    a: '是的，天美麻花星空影视平台上所有电视剧全集、电影大全、综艺动漫内容均免费在线观看，无需付费或订阅会员。平台通过合理的广告展示维持运营，确保用户可以持续享受免费高清影视服务。',
  },
  {
    q: '支持哪些设备观看？画质怎么样？',
    a: '天美麻花星空影视支持手机、平板、电脑以及大屏TV版全端观看。平台提供超清蓝光画质选项，最高支持4K分辨率，自动根据您的网络状况和屏幕进行适配，确保最佳观看体验。所有内容均支持不缓冲流畅播放。',
  },
  {
    q: '需要注册账号才能观看吗？',
    a: '不需要。天美麻花星空影视无需注册即可直接在线观看所有内容。如果您希望保存播放进度、收藏喜欢的影片或同步观看记录到多台设备，可以免费注册账号享受这些便捷功能。',
  },
  {
    q: '内容更新频率如何？新剧多久上线？',
    a: '平台内容每日更新，热门电视剧和综艺节目通常在播出后24小时内上线。院线电影下线后会尽快上架蓝光版本。动漫新番每周同步更新，确保您不会错过任何精彩内容。',
  },
  {
    q: '观看时出现缓冲或卡顿怎么办？',
    a: '天美麻花星空影视采用多线路CDN加速技术，正常情况下不会出现缓冲问题。如果遇到卡顿，建议尝试切换播放线路（在播放器设置中可调）、降低画质档位或检查您的网络连接。大部分用户反馈即使在高峰期也能流畅播放。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            关于天美麻花星空影视的常见疑问与解答
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {FAQS.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-300/15 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-3 p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 pr-2">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className={`text-foreground-500 text-lg ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-400 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}